import { useEffect } from 'react';

// High priority images that should load first
const HIGH_PRIORITY_IMAGES = [
  require('../../assets/biden_with_people.png'),      // Game background
  require('../../assets/trump_without_people.png'),   // Trump background
  require('../../assets/flappy_trump_cleaned.png'),   // StartScreen image
  require('../../assets/space.png'),                  // Space bar icon
];

// Other game assets that should load after
const GAME_ASSETS = [
  require('../../assets/trump_transparent.png'),      // Bird
  require('../../assets/tower_long_top_2.jpg'),              // Pipe top
  require('../../assets/tower_long.jpg'),           // Pipe bottom
];

// Chapter backgrounds for the storyline themes
const CHAPTER_BACKGROUNDS = [
  require('../../assets/chapters/chapter_deals_bg.png'),
  require('../../assets/chapters/chapter_war_bg.png'),
  require('../../assets/chapters/chapter_debt_bg.png'),
  require('../../assets/chapters/chapter_ai_bg.png'),
  require('../../assets/chapters/chapter_fallout_bg.png'),
];

// Storyline event illustrations
const STORY_IMAGES = Object.values(require('../Score/storyline').storyline)
  .map(event => event.img)
  .filter(Boolean);

const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = resolve;
    img.onerror = reject;
  });
};

const ImagePreloader = () => {
  useEffect(() => {
    const preloadAll = async () => {
      try {
        // First load high priority images
        await Promise.all(HIGH_PRIORITY_IMAGES.map(preloadImage));

        // Then load game assets
        await Promise.all(GAME_ASSETS.map(preloadImage));

        // Then chapter backgrounds
        await Promise.all(CHAPTER_BACKGROUNDS.map(preloadImage));

        // Finally load storyline images
        await Promise.all(STORY_IMAGES.map(preloadImage));
      } catch (error) {
        console.error('Error preloading images:', error);
      }
    };

    preloadAll();
  }, []);

  return null; // This component doesn't render anything
};

export default ImagePreloader;
